function siteSelectDirective() {
	return {
		scope : {
			idClient : '=*',
			site : '=?',
			onSiteChange : '&',
			required : '@'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/siteSelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'clientService', function($scope, $window, alertService, clientService) {
			var init = true;

			$scope.valueWasChangedFromSelector = false;
			$scope.availableSites = [];

			if (angular.isUndefined($scope.required))
				$scope.required = false;

			$scope.searchSite = function(query) {
				if ($scope.sitesCount && $scope.sitesLimit) {
					if ($scope.sitesCount <= $scope.sitesLimit)
						return;
				}
				var filter = {};

				if (query) {
					filter.name = query;
				}

				if (!$scope.idClient) {
					$scope.availableSites = [];
					//if ($scope.site)
						//$scope.site = {};
					return;
				}

				clientService.searchSitesBasicInfo($scope.idClient, filter).then(function(response) {
					var resp = response.getData();
					$scope.availableSites = resp.results;
					if (!$scope.sitesCount)
						$scope.sitesCount = resp.totalRegisters;
					$scope.sitesLimit = resp.limit;

					/*
					 * se hace solo la primera vez y es por si solo se conoce el
					 * id del sitio que se quiere seleccionar
					 */
					if ($scope.site.id && init) {
						init = false;
						var sel = $scope.availableSites.find(function(s) {
							return s.id == $scope.site.id;
						});
						if (sel) {
							$scope.site.selected = [];
							$scope.site.selected.push(sel);
						} else {
							clientService.getClientSite($scope.idClient, $scope.site.id).then(function(response) {
								$scope.site.selected = [];
								$scope.site.selected.push(response.getData());
							});
						}
						$scope.site.id = undefined;
					}

				}, function(response) {
					// on error
				});
			};

			$scope.siteChanged = function(site) {
				$scope.valueWasChangedFromSelector = true;
				if ($scope.onSiteChange != undefined) {
					$scope.onSiteChange({
						siteSelected : site
					});
				}
			};

			$scope.$watch('idClient', function(newValue, oldValue) {
				$scope.sitesCount = undefined;
				$scope.sitesLimit = undefined;
				$scope.searchSite();
			});

		} ],
		link : function(scope, elem, attr) {

		}
	};
};

module.directive('siteSelect', [ siteSelectDirective ]);
